// Shared style tokens for the executive filter bar inputs so the dropdowns
// match the rest of the system (component/Select/FilterSelect) — same height
// (2rem), borderInput chrome, themeSecondColor06 hover, FontAwesome caret.
import { colors } from 'constants/theme'

// sx for the outlined MUI Select used by FilterDatePreset and
// FilterBranchSelect. Matches StyledFilterSelect's outline + hover + sizing
// plus BasicSelect's open-state teal accent (themeSecondColor on the focus
// outline, caret rotates when open).
export const EXEC_SELECT_SX = {
  height: '2rem',
  backgroundColor: colors.white,
  '.MuiSelect-select': { padding: '0 1rem' },
  '.MuiOutlinedInput-notchedOutline': { borderColor: colors.borderInput },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: colors.black12 },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: `${colors.themeSecondColor} !important`,
    borderWidth: '1px !important',
  },
  '.MuiSvgIcon-root': { color: colors.black, fontSize: '20px', right: '0.5rem' },
  '&.Mui-focused .MuiSvgIcon-root': {
    color: colors.themeSecondColor,
    transform: 'rotate(180deg)',
  },
}

// MenuProps applied to executive Selects so dropdown items match the
// system look: teal-tinted bg + teal text on hover AND on the currently-
// selected row (matches BasicSelect / FilterSelect / SelectAddress).
export const EXEC_SELECT_MENU_PROPS = {
  PaperProps: {
    sx: {
      '.MuiMenuItem-root': {
        '&:hover': {
          backgroundColor: `${colors.themeSecondColor06} !important`,
          color: colors.themeSecondColor,
        },
        '&.Mui-selected': {
          backgroundColor: `${colors.themeSecondColor06} !important`,
          color: `${colors.themeSecondColor} !important`,
        },
        '&.Mui-selected:hover': {
          backgroundColor: `${colors.themeSecondColor06} !important`,
        },
      },
    },
  },
}

// sx for the native date TextField used by FilterDatePreset (custom range).
// Same border + height as the Select so the inputs visually align, with the
// same teal focus accent.
export const EXEC_DATE_INPUT_SX = {
  backgroundColor: colors.white,
  '.MuiOutlinedInput-root': { height: '2rem' },
  '.MuiOutlinedInput-input': { padding: '0 0.75rem' },
  '.MuiOutlinedInput-notchedOutline': { borderColor: colors.borderInput },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: colors.black12 },
  '.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: `${colors.themeSecondColor} !important`,
    borderWidth: '1px !important',
  },
}
